import { TextField } from '@material-ui/core';
import CustomDatePicker from 'components/common/input/CustomDatePicker';
import MuiWrapper from 'components/common/input/MuiWrapper';
import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { color } from 'styles/utils';
import cx from 'classnames';
import { languageList, languageFilters, projectProcessFlagList } from 'lib/mapper';
import CheckIcon from 'components/base/icons/CheckIcon';
import { useTranslation } from 'react-i18next';
import { icon_magnifier } from 'components/base/images';
import T from 'components/common/text/T';
import IconButton from '@material-ui/core/IconButton';
import { useDidUpdateEffect } from 'lib/utils';
import moment from 'moment';
import { useShallowAppSelector } from 'store/hooks';
import { Clear } from '@material-ui/icons';

export interface PatientSearchFilterProps {
  viewType?: string;
  period: {
    value: any | null;
    onChange: (e: any) => void;
    setValue: (value: any | null) => void;
  };
  checkedProjectProcess: {
    value: Set<number>;
    onChange: (e: any) => void;
    setValue: (value: Set<number>) => void;
  };
  isPms: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  lastNameInitial: {
    value: string;
    onChange: (e: any) => void;
    setValue: (value: string) => void;
  };
  projectType?: { value: number; onChange: (e: any) => void; setValue: (value: number) => void };
  keyword: { value: string; onChange: (e: any) => void; setValue: (value: string) => void };
  isSubmit?: boolean | null;
  onSearch: () => void;
}

const PatientSearchFilter = ({
  viewType,
  period,
  checkedProjectProcess,
  isPms,
  projectType,
  keyword,
  lastNameInitial,
  isSubmit,
  onSearch,
}: PatientSearchFilterProps) => {
  const {
    language,
  }: {
    language: string;
  } = useShallowAppSelector(state => ({
    language: state.base.language,
  }));
  const { t } = useTranslation();
  const [filterBase, setFilterBase] = useState(language);
  const [selectedWord, setSelectedWord] = useState<string>('');
  const [selectedPeriod, setSelectedPeriod] = useState<number>(0);
  const [isCheckAll, setIsCheckAll] = useState<boolean>(true);
  const [isFilterTrans, setIsFilterTrans] = useState(false);

  const handleChangePeriod = (select: number) => {
    const endDate = moment().utcOffset(0);
    endDate.set({ hour: 23, minute: 59, second: 59, millisecond: 59 });
    endDate.toISOString();
    endDate.format();
    if (select === -1) {
      period.setValue(null);
      setTimeout(() => {
        setSelectedPeriod(-1);
      }, 150);
    }
    if (select === 0) {
      period.setValue(null);
      setSelectedPeriod(0);
    }
    if (select === 1) {
      const startDate = moment().utcOffset(0);
      startDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      startDate.toISOString();
      startDate.format();
      const dateValue = [startDate, endDate];
      period.setValue(dateValue);
      setSelectedPeriod(1);
    }
    if (select === 3) {
      const startDate = moment().subtract(3, 'days').utcOffset(0);
      startDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      startDate.toISOString();
      startDate.format();
      const dateValue = [startDate, endDate];
      period.setValue(dateValue);
      setSelectedPeriod(3);
    }
    if (select === 7) {
      const startDate = moment().subtract(7, 'days').utcOffset(0);
      startDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      startDate.toISOString();
      startDate.format();
      const dateValue = [startDate, endDate];
      period.setValue(dateValue);
      setSelectedPeriod(7);
    }
  };

  useEffect(() => {
    const test = languageList?.find(item => item.code === filterBase);

    console.log('HDS] test _____ ', test);
  }, [filterBase]);

  useDidUpdateEffect(() => {
    // Material check 시, size 비교를 통한  all 측정
    if (checkedProjectProcess.value.size === projectProcessFlagList.length - 4) {
      setIsCheckAll(true);
    } else {
      setIsCheckAll(false);
    }
  }, [checkedProjectProcess.value, isCheckAll, projectProcessFlagList]);

  const handleCheckAllStage = (checkAll: boolean) => {
    checkedProjectProcess.setValue(new Set([]));
    setIsCheckAll(!checkAll);
    if (!checkAll) {
      projectProcessFlagList.forEach((item: any) => {
        if (item.id === -2) return; // urgent
        if (item.id === -1) return; //pending
        if (item.id === 0) return; // new
        if (item.id === 4) return; // cam
        checkedProjectProcess.onChange({ value: item.id });
      });
    }
  };

  const handleClear = () => {
    keyword.setValue('');
  };

  const handleChangePms = (checkValue: number) => {
    if (checkValue === 1) {
      isPms.onChange({ value: 0 });
    } else {
      isPms.onChange({ value: 1 });
    }
  };

  return (
    <StyledProjectSearchFilter data-component-name="PatientSearchFilter" viewType={viewType}>
      <div className="projectList__filter_row searchFilter">
        <MuiWrapper
          className="patientSearchFilter__search_wrapper"
          config={{
            borderColor: 'transparent',
            activeBorderColor: 'transparent',
            hoverBorderColor: 'transparent',
          }}
        >
          <>
            <TextField
              minRows={1}
              maxRows={1}
              className="radius-md patientSearchFilter__search_bar"
              variant="outlined"
              fullWidth
              inputProps={{
                fontSize: 13,
                fontWeight: 400,
              }}
              placeholder={t('SEACH_FOR_PATIENT')}
              value={keyword.value || ''}
              onChange={keyword.onChange}
              onKeyPress={e => e.key === 'Enter' && onSearch()}
              InputProps={{
                endAdornment: keyword.value.length > 0 && (
                  <IconButton onClick={handleClear} edge="end">
                    <Clear />
                  </IconButton>
                ),
              }}
            />
            <button className="btn-reset patientSearchFilter__search_btn" onClick={onSearch}>
              <img src={icon_magnifier} alt="search" />
            </button>
          </>
        </MuiWrapper>
      </div>
      <div className="projectList__filter_row initialFilter">
        {/* {useMemo(
          () => (
            <div className="initialFilter__box">
              <div
                className={cx('initialFilter__item all', {
                  active: !!(lastNameInitial.value === ''),
                })}
                onClick={() => {
                  lastNameInitial.setValue('');
                }}
              >
                {languageList?.find(item => item.code === filterBase)?.all}
              </div>
              <div className="initialFilter__item_box">
                {languageFilters
                  ?.find(item => item.code === filterBase)
                  ?.filters.map((item: string, idx: number) => {
                    return (
                      <div
                        key={idx}
                        className={cx('initialFilter__item initial', {
                          first: idx === 0,
                          active: !!(lastNameInitial.value === item),
                        })}
                        onClick={() => {
                          lastNameInitial.setValue(item);
                        }}
                      >
                        {item}
                      </div>
                    );
                  })}
              </div>
              <div
                className="initialFilter__item translate"
                onClick={() => {
                  let chagneCode;
                  if (!isFilterTrans) {
                    chagneCode = languageList.find(item => item.code === language)?.transCode;
                  } else {
                    chagneCode = languageList.find(item => item.code === language)?.code;
                  }
                  if (!chagneCode) return;
                  setIsFilterTrans(!isFilterTrans);
                  setFilterBase(chagneCode);
                }}
              >
                {language === 'en'
                  ? ''
                  : isFilterTrans
                  ? languageList.find(item => item.code === language)?.transDefaultText
                  : languageList.find(item => item.code === language)?.transText}
              </div>
            </div>
          ),
          [lastNameInitial.value, selectedWord, filterBase],
        )} */}
      </div>
      <div className="projectList__filter_row dateStageFilter">
        <div className="dateStageFilter__date_box">
          <IconButton
            className={cx('dateStageFilter__date_item all', {
              active: selectedPeriod === 0,
            })}
            onClick={() => {
              handleChangePeriod(0);
            }}
          >
            <T>FILTER_DATE_ALL</T>
          </IconButton>
          <IconButton
            className={cx('dateStageFilter__date_item today', {
              active: selectedPeriod === 1,
            })}
            onClick={() => {
              handleChangePeriod(1);
            }}
          >
            <T>FILTER_DATE_TODAY</T>
          </IconButton>
          <IconButton
            className={cx('dateStageFilter__date_item three', {
              active: selectedPeriod === 3,
            })}
            onClick={() => {
              handleChangePeriod(3);
            }}
          >
            <T>FILTER_DATE_THREE</T>
          </IconButton>
          <IconButton
            className={cx('dateStageFilter__date_item week', {
              active: selectedPeriod === 7,
            })}
            onClick={() => {
              handleChangePeriod(7);
            }}
          >
            <T>FILTER_DATE_SEVEN</T>
          </IconButton>
          <IconButton
            className={cx('dateStageFilter__date_item select', {
              active: selectedPeriod === -1,
            })}
            onClick={() => {
              handleChangePeriod(-1);
            }}
          >
            <T>FILTER_DATE_CUSTOM</T>
          </IconButton>
          <div
            className={cx('dateStageFilter__date_item datePicker', {
              activePicker: selectedPeriod === -1,
            })}
          >
            <CustomDatePicker
              type="rangeDate"
              fullWidth
              borderColor="#B5B7C1"
              height={30}
              value={period.value}
              onChange={period.onChange}
              className={cx({
                error: isSubmit ? !period.value : false,
              })}
              isClient={true}
            />
          </div>
        </div>

        <div className="dateStageFilter__filter_box">
          <ul className="dateStageFilter__filter_connect">
            <li
              className={cx(`dateStageFilter__filter_connect_item`, {
                active: isPms.value === 1,
              })}
              onClick={() => handleChangePms(isPms.value)}
            >
              <span
                className={`dateStageFilter__filter_connect_check`}
                style={{
                  borderColor: isPms.value === 1 ? 'transparent' : '#ccc',
                  backgroundColor: isPms.value === 1 ? '#FFA41B' : 'transparent',
                }}
              >
                {isPms.value === 1 && <CheckIcon />}
              </span>
              <T>PATIENT_CONNECT</T>
            </li>
          </ul>

          <ul className="dateStageFilter__filter_stage_list">
            <li
              className={cx(`dateStageFilter__filter_stage_item`, {
                active: isCheckAll,
              })}
              onClick={() => {
                handleCheckAllStage(isCheckAll);
              }}
            >
              <span
                className={`dateStageFilter__filter_stage_check`}
                style={{
                  borderColor: isCheckAll ? 'transparent' : '#ccc',
                  backgroundColor: isCheckAll ? '#000' : 'transparent',
                }}
              >
                {isCheckAll && <CheckIcon />}
              </span>
              All
            </li>
            {projectProcessFlagList.map((item, idx) => {
              if (item.id === -2) return;
              if (item.id === -1) return;
              if (item.id === 0) return;
              if (item.id === 4) return;
              return (
                <li
                  className={cx(`dateStageFilter__filter_stage_item`, {
                    active: checkedProjectProcess.value.has(item.id),
                  })}
                  key={idx}
                  onClick={() => checkedProjectProcess.onChange({ value: item.id })}
                >
                  <span
                    className={`dateStageFilter__filter_stage_check ${item.id}`}
                    style={{
                      borderColor: checkedProjectProcess.value.has(item.id)
                        ? 'transparent'
                        : '#ccc',
                      backgroundColor: checkedProjectProcess.value.has(item.id)
                        ? item.color
                        : 'transparent',
                    }}
                  >
                    {checkedProjectProcess.value.has(item.id) && <CheckIcon />}
                  </span>
                  {t(`${item.code}`)}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </StyledProjectSearchFilter>
  );
};

const StyledProjectSearchFilter = styled.div<{ viewType: string | undefined }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  position: relative;

  .datePicker__box {
    width: 250px;
    .ant-picker {
      border-color: transparent;
    }
  }
  .projectList__filter_row {
    .filterWord__item {
      &:hover {
        cursor: pointer;
      }
    }
  }
  .searchFilter {
    .patientSearchFilter__search_wrapper {
      position: relative;
      width: ${({ viewType }) => (viewType === 'modal' ? '310px' : '390px')};
      height: 46px;
      .MuiOutlinedInput-input {
        font-size: 13px;
        font-weight: 400;
      }
      .MuiInputBase-root {
        background-color: #ffffff;
        border: 1px solid #e1e1e1;
      }
      .MuiIconButton-edgeEnd {
        margin-right: 30px;
      }
      .patientSearchFilter__search_btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 0;
        top: 0;
        width: 46px;
        height: 46px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        background-color: ${color.navy_blue};
      }
    }
  }
  .initialFilter {
    display: flex;
    .initialFilter__box {
      display: flex;
      width: 100%;
      height: 50px;
      background-color: #f4f5fa;
      display: flex;
      align-items: center;
      .initialFilter__item_box {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
      }
      .initialFilter__item {
        cursor: pointer;
        text-align: center;
        font-size: 16px;
        &.active {
          color: #00a6e2;
        }
        &.all {
          width: 92px;
          font-weight: 500;
        }
        &.initial {
          height: 20px;
          width: 100%;
          &.first {
            border-left: 1px solid #ccccd4;
          }
          border-right: 1px solid #ccccd4;
          /* &.en {
            width: 56px;
          }
          width: 104px; */
        }
        &.translate {
          width: 92px;
          font-weight: 500;
        }
      }
    }
  }
  .dateStageFilter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 32px;
    .dateStageFilter__date_box {
      display: flex;
      column-gap: 6px;
      .dateStageFilter__date_item {
        height: 32px;
        border: 1px solid #ccccd4;
        border-radius: 4px;
        font-size: 14px;
        color: #444444;
        background-color: #ffffff;
        &.active {
          border: 1px solid #00a6e2;
          color: #00a6e2;
        }
        &.all,
        &.select {
          width: 90px;
        }
        &.today,
        &.three,
        &.week {
          width: 63px;
        }
        &.datePicker {
          display: none;
          &.activePicker {
            display: block;
          }
        }
      }
    }

    .dateStageFilter__filter_box {
      display: flex;
      .dateStageFilter__filter_stage_list {
        display: flex;
        align-items: center;
        .dateStageFilter__filter_stage_item {
          display: inline-flex;
          align-items: center;
          margin-right: 40px;
          cursor: default;
          &:first-child {
            /* margin-left: 40px; */
            margin-left: 20px;
          }
          &:last-child {
            margin-right: 10px;
          }
          font-size: 13px;
          .dateStageFilter__filter_stage_check {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
            width: 20px;
            height: 20px;
            border-radius: 4px;
            background-color: transparent;
            border: 1px solid white;
          }
        }
      }
      .dateStageFilter__filter_connect {
        display: flex;
        align-items: center;
        border-right: 1px solid #e1e1e7;
        .dateStageFilter__filter_connect_item {
          display: inline-flex;
          align-items: center;
          cursor: default;
          font-size: 13px;
          margin-right: 20px;
          .dateStageFilter__filter_connect_check {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
            width: 20px;
            height: 20px;
            border-radius: 4px;
            background-color: transparent;
            border: 1px solid white;
          }
        }
      }
    }
  }
`;

export default React.memo(PatientSearchFilter);
